import { GLOBALS } from '../globals'
import { createTextVariantComponents } from '../setup-factories'

export const { TextTitle, TextTitleSmall } = createTextVariantComponents({
  Title: {
    font: {
      family: GLOBALS.font.title.family,
      weight: GLOBALS.font.title.weight,
      size: GLOBALS.font.title.size,
      lineHeight: GLOBALS.font.title.lineHeight,
      color: GLOBALS.font.title.color
    }
  },
  TitleSmall: {
    font: {
      family: GLOBALS.font.title.family,
      size: '13px',
      lineHeight: '18px',
      color: GLOBALS.font.title.color
    }
  }
})
